import { Alert, Dialog, Paragraph } from "@fronterahealth/frontera-ui-components";

interface ConfirmPublishDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  templateName?: string;
  templateDescription?: string;
  onConfirm: (description?: string) => void;
  onCancel?: () => void;
}

export const ConfirmPublishDialog: React.FC<ConfirmPublishDialogProps> = ({
  open,
  setOpen,
  templateName,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      title="Publish Template"
      open={open}
      setOpen={setOpen}
      primaryButton={{
        text: "Publish Template",
        onClick: () => {
          onConfirm();
        },
      }}
      secondaryButton={{
        text: "Cancel",
        onClick: onCancel,
      }}
      size="2xl"
    >
      <Paragraph className="mb-4" displayType="normal" colorType="primary">
        Are you sure you want to publish &quot;{templateName}&quot;? Once published, this template cannot be edited and
        will be available for creating new reports.
      </Paragraph>
      <Alert
        title=""
        appearance="neutral"
        text={
          <p className="-mt-2">
            Publishing will make this template read-only. If you need to make changes later, you&apos;ll need to create
            a copy.
          </p>
        }
      />
    </Dialog>
  );
};
